import { CustomErrorType } from "../interfaces/CustomErrorType";

export default {
    code: 'ERR_INVALID_PARAMS',
    statusCode: 400,
    message: {
        en: 'Invalid parameters',
    },
} as CustomErrorType;